import styled from 'styled-components';

import { Text, Flex, Container } from '@olxbr/ds-web';

export const Wrapper = styled(Flex)`
  width: 100%;
  margin-top: 20px;
  padding: 0 var(--spacing-stack-xxxs);
`;

export const CardsContainer = styled.div`
  width: 100%;
  max-width: 970px;
`;

export const PaymentText = styled(Text.BodyLarge)`
  font-weight: var(--font-weight-bold);
  padding-right: var(--spacing-stack-xxxs);
`;

export const PaymentContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  
  @media (min-width: 1030px) {
    flex-direction: row;
  }
`;

export const NeedHelpContainer = styled(Container)`
  flex-direction: column;  
  align-items: center;
  margin: var(--spacing-stack-xxxs) 0;

  @media (min-width: 1030px) {
    flex-direction: row;
  }
`;

export const TextContainer = styled(Flex)`
  align-items: center;
  margin: var(--spacing-stack-xxxs) 0;

  @media (min-width: 1030px) {
    margin: 0 var(--spacing-stack-xxxs);
  }
`;

export const WrapperPlansDescription = styled(Flex)`
  text-align: center;
  max-width: 600px;
  padding: 0 var(--spacing-stack-xxxs);
  
  @media (min-width: 1030px) {
    max-width: 970px;
    padding: 0;
  }
`;

export const IconsContainer = styled(Flex)`
  svg {
    padding-right: var(--spacing-inset-xs);
  }
`;
